import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Wrapper, EyeIcon } from './styled';

const PasswordHeader = ({ hidePass, setHidePass }) => {
  const onClick = (e) => {
    e.stopPropagation();
    setHidePass(!hidePass);
  };

  return (
    <Wrapper>
        <FormattedMessage id="credentials.table.columns.password" />
        <EyeIcon onClick={ onClick } />
    </Wrapper>
  );
};

export default PasswordHeader;
